<template>
  <dl class="integration-metadata">
    <div v-for="(value, key) in visibleFields" :key="key">
      <dt>{{ key }}</dt>
      <dd>{{ value }}</dd>
    </div>
  </dl>
</template>

<script>
export default {
  props: { fields: { type: Object, required: true } },
  computed: {
    visibleFields() {
      return Object.keys(this.fields).reduce((result, key) => {
        const value = this.fields[key]
        const emptyCollection = typeof value === 'object' && value !== null && !Object.keys(value).length
        if (value !== null && value !== undefined && value !== '' && value !== '—' && !emptyCollection) result[key] = value
        return result
      }, {})
    }
  }
}
</script>
